// combinedSchema.js
import * as yup from 'yup';
import { schemaStart } from './ValidationSchemaStart';
import { schemaNext } from './ValidationSchemaNext';
import { schemaPayment } from './ValidationSchemaPayment';

export const combinedSchema = yup.object({
    start: schemaStart,
    next: schemaNext,
    payment: schemaPayment
});